import { DataItem } from "#common/text/DataItem"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import CardMedia from "@mui/material/CardMedia"
import Grid2 from "@mui/material/Unstable_Grid2"
import { usePromotionsContext } from "Components/promotions/PromotionContext"
import { PromotionColaboradorButtons } from "./PromotionColaboradorButtons"
// import { CardButtons } from "./CardButtons"

export function PromotionColaborador({ detail, disable = false }) {
	let estado = "Espera de autorización"

	if (detail.authorized === true) estado = "Aprobado"
	else if (detail.authorized === false) estado = "Rechazada"

	if (typeof detail.authorized === "boolean") disable = true

	return (
		<Card
			sx={{
				display: "flex",
				justifyContent: "space-between",
				width: "100%",
				padding: "10px",
				borderRadius: "15px",
				border: "1px solid #e0e0e0",
			}}
		>
			<DetailImg image={detail?.photo} />

			<CardContent sx={{ flexGrow: 1 }}>
				<Details detail={detail} />
			</CardContent>

			<PromotionColaboradorButtons disable={disable} detail={detail} />
		</Card>
	)
}

const DetailImg = ({ image }) => {
	return (
		<CardMedia
			sx={{
				minWidth: "150px",
				maxWidth: "150px",
				borderRadius: "15px",
				padding: "10px",
			}}
			component="img"
			image={image}
			title="Colaborador"
			onError={(e) => {
				e.target.onerror = null
				e.target.src = "https://imagenespublicas.s3.us-east-2.amazonaws.com/usuario.webp"
			}}
		/>
	)
}

const Details = ({ detail }) => {
	const { promotion } = usePromotionsContext()
	const { authorized } = detail
	let estado = ""

	if (authorized === null) estado = "Espera de autorización"
	else if (authorized === true) estado = "Aprobada"
	else if (authorized === false) estado = "Rechazada"

	const data = [
		{
			label: "",
			value: "name",
			variant: "h6",
			fontWeight: "bold",
			grid: { md: 12, lg: 12 },
		},
		{
			label: "Puesto Actual",
			value: "old_profile",
			grid: { md: 12, lg: 4 },
		},
		{
			label: "Puesto Requerido",
			value: "new_profile",
			grid: { md: 12, lg: 4 },
		},
		{
			label: estado,
			value: "authorization_name",
			grid: { md: 12, lg: 4 },
			// notShow:
			// 	promotion.status_id !== STATUS.Finalizada &&
			// 	promotion.status_id !== STATUS.Aprobada_RH,
		},
	]

	const dataItem = data.map((item) => {
		if (item?.notShow) return null
		return (
			<Grid2 {...item.grid} key={item.value}>
				<DataItem {...item} value={detail[item.value]} />
			</Grid2>
		)
	})

	return (
		<Grid2 container spacing={2} columnSpacing={2}>
			{dataItem}
		</Grid2>
	)
}
